export default "__VITE_ASSET__DNy0KPXF__"